import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '../translate.pipe';

@Pipe({
  name: 'translateMediumDate',
})
export class TranslateMediumDatePipe implements PipeTransform {
  month: number;
  day: number;
  year: number;
  
  constructor(
    private translate: TranslatePipe
  ){}

  transform(date: Date): string {
    this.month = date.getMonth();
    this.day = date.getDate();
    this.year = date.getFullYear();
    return `${this.translate.transform(`date.month.short.m${this.month}`)} ${this.day}, ${this.year}`;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/pipes/translate-medium-date.pipe.ts